import { Dialog, DialogTitle, DialogContent } from "@/components/ui/dialog";
import { Modal } from "@/components/ui/customs/modal";
import { useGetOneExpeditionBo } from "@/api/expedition.api";
import { Loader2 } from "lucide-react";
import {
  GetAllExpeditionBoResponseDtoExpedition,
  GetOneExpeditionBoResponseDto,
} from "@/types/api/api-types";
import { useGetCompanyBOV1 } from "@/api/company.api";
import { ReQuotationModal } from "./reQuotation";
import { ReCustomQuotationModalContent } from "./reCustomQuotation";
import { useGetCustoms } from "@/api/customs.api";
import { useTranslation } from "react-i18next";

type Props = {
  expeditionRow: GetAllExpeditionBoResponseDtoExpedition | GetOneExpeditionBoResponseDto;
  open: boolean;
  onClose: () => void;
};

export const ReExpeditionBoModal = ({ expeditionRow, open, onClose }: Props) => {
  const { t } = useTranslation("boExpeditionForm");
  const {
    data: expedition,
    isLoading: isLoadingExpedition,
    isError: isErrorExpedition,
  } = useGetOneExpeditionBo(expeditionRow.id);
  const {
    data: company,
    isLoading: isLoadingCompany,
    isError: isErrorCompany,
  } = useGetCompanyBOV1(expeditionRow.companyId);
  const { data: customs, isPending: isCustomsPending, isError: isErrorCustoms } = useGetCustoms();

  const isLoading = isLoadingExpedition || isLoadingCompany || isCustomsPending;
  const isError = isErrorExpedition || isErrorCompany || isErrorCustoms;

  if (isLoading) {
    return (
      <Modal open={open} onClose={onClose} title={t("reExpeditionModal.detailsTitle")} size="lg">
        <div className="flex w-full justify-center py-8">
          <Loader2 className="animate-spin" />
        </div>
      </Modal>
    );
  }

  if (isError || !expedition || !company || !customs) {
    return (
      <Modal
        open={open}
        onClose={onClose}
        title={t("reExpeditionModal.detailsTitle")}
        size="sm"
        dismissible
      >
        <p>{t("reExpeditionModal.error")}</p>
      </Modal>
    );
  }

  if (expedition.customQuotation) {
    return (
      <Dialog open={open}>
        <DialogContent
          className="max-h-[90vh] w-[90vw] gap-0 overflow-y-hidden border-none bg-transparent p-0 shadow-none xl:max-w-[1600px]"
          aria-describedby={undefined}
          showClose={false}
        >
          <DialogTitle
            className="bg-brand600 rounded-t-lg p-4 text-white"
            aria-describedby="re-expedition"
          >
            {t("reExpeditionModal.title")}
          </DialogTitle>
          <ReCustomQuotationModalContent
            expedition={expedition}
            company={company}
            onClose={onClose}
            customs={customs}
          />
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={open}>
      <DialogContent
        className="max-h-[90vh] w-[90vw] gap-0 overflow-y-hidden border-none bg-transparent p-0 shadow-none xl:max-w-[1600px]"
        aria-describedby={undefined}
        showClose={false}
      >
        <DialogTitle
          className="bg-brand600 rounded-t-lg p-4 text-white"
          aria-describedby="re-expedition"
        >
          {t("reExpeditionModal.title")}
        </DialogTitle>
        <ReQuotationModal
          expedition={expedition}
          company={company}
          customs={customs}
          onClose={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};
